var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAirparkPGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H17C21.4183 0 25 3.58172 25 8V17C25 21.4183 21.4183 25 17 25H8C3.58172 25 0 21.4183 0 17V8Z",
    fill: "#33D085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2496 10.333C19.2496 13.8306 16.4648 16.666 13.0296 16.666C11.7172 16.666 10.4997 16.2521 9.49614 15.5456V19.5501H6.80957V10.3331C6.80957 10.3331 6.80957 10.3331 6.80957 10.3331C6.80957 6.83547 9.59436 4 13.0296 4C16.4648 4 19.2496 6.83537 19.2496 10.333ZM16.563 10.333C16.563 12.3199 14.9811 13.9306 13.0296 13.9306C11.0781 13.9306 9.49617 12.3199 9.49617 10.333C9.49617 8.34605 11.0781 6.73535 13.0296 6.73535C14.9811 6.73535 16.563 8.34605 16.563 10.333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAirparkPGreen);
export default __webpack_public_path__ + "static/media/ico_airpark_p_green.2d9f245d011baf234776da07115623fb.svg";
export { ForwardRef as ReactComponent };